import find from 'lodash/find';
import get from 'lodash/get';

export default {
  computed: {
    selectedAdventure() {
      return this.$store.state.departure.adventure;
    },

    availableDepartures() {
      return this.$store.state.departure.adventure.departures;
    },

    selectedDeparture() {
      return this.$store.state.departure.selectedDeparture;
    },

    selectedDepartureQuantity() {
      return this.$store.state.departure.selectedDepartureQuantity;
    },

    adventureExtras() {
      return get(this.$store.state, 'departure.adventure.extras', []);
    },

    departureExtras() {
      return get(this.$store.state, 'departure.selectedDeparture.extras', []);
    },

    departureAddons() {
      if (this.$store.state.departure.selectedDeparture) {
        return this.$store.state.departure.adventure.addons;
      }

      return [];
    },

    allExtras() {
      if (!this.selectedDeparture) {
        return this.adventureExtras;
      }

      return this.adventureExtras.concat(this.departureExtras);
    },

    selectedAddons() {
      return this.$store.state.departure.addons;
    },

    selectedExtras() {
      return this.$store.state.departure.extras;
    },

    selectedAddonExtras() {
      return this.$store.state.departure.addon_extras;
    },

    adventureIsEnquireOnly() {
      return get(this.$store.state, 'departure.adventure.enquire_only');
    },

    departureIsEnquireOnly() {
      return get(this.$store.state, 'departure.selectedDeparture.enquire_only');
    },

    peopleCount() {
      return this.$store.state.departure.peopleCount;
    },
  },

  methods: {
    compileAddonsAndExtrasForXHR() {
      const output = {};

      output.adventure = this.selectedAdventure.slug;
      output.departure = this.selectedDeparture.uuid;
      output.addons = [];
      output.extras = [];

      this.departureAddons.forEach((departureAddon) => {
        const addon = find(this.selectedAddons, ['slug', departureAddon.slug]);

        if (!addon) {
          return;
        }

        const addonData = {
          id: addon.slug,
          quantity: addon.quantity,
          extras: [],
        };

        departureAddon.extras.forEach((departureAddonExtra) => {
          const addonExtra = find(this.selectedAddonExtras, ['uuid', departureAddonExtra.uuid]);

          if (!addonExtra) {
            return;
          }

          addonData.extras.push({
            id: addonExtra.uuid,
            quantity: addonExtra.quantity,
          });
        });

        output.addons.push(addonData);
      });

      this.allExtras.forEach((availableExtra) => {
        const extra = find(this.selectedExtras, ['uuid', availableExtra.uuid]);

        if (!extra) {
          return;
        }

        output.extras.push({
          id: extra.uuid,
          quantity: extra.quantity,
        });
      });

      return output;
    },

    onChangePeopleCount(e) {
      this.$store.commit('departure/UPDATE_PEOPLE_COUNT', e.target.value);
    },
  },
};
